/* tslint:disable */

export function component(
    options: {
        controllerAs?: string;
        bindings?: any;
        template?: string;
        templateCacheUrl?: string;
        transclude?: any;
        require?: any;
        controller: any;
    }
) {
    options["templateUrl"] = options.templateCacheUrl;

    return options;
}